module.exports = __webpack_public_path__ + "img/leaseMgt.42cc7d9b.svg";